import {
  ACTIVITIES_GET,
  ACTIVITY_ADD,
  ACTIVITY_GET,
  ACTIVITY_EDIT,
  ACTIVITY_UPLOADFILE,
  ACTIVITY_DELETE,
  ACTIVITY_RESET_SEARCH,
} from './reduxConstant';

export const activitiesGet = (activities) => {
  return {
    type: ACTIVITIES_GET,
    payload: {
      activities,
    },
  };
};

export const activityAdd = (activity) => {
  return {
    type: ACTIVITY_ADD,
    payload: {
      activity,
    },
  };
};

export const activityGet = (activity) => {
  return {
    type: ACTIVITY_GET,
    payload: {
      activity,
    },
  };
};

export const activityEdit = (activity) => {
  return {
    type: ACTIVITY_EDIT,
    payload: {
      activity,
    },
  };
};

export const activityUploadFile = (status) => {
  return {
    type: ACTIVITY_UPLOADFILE,
    payload: {
      status,
    },
  };
};

export const activityDelete = (activity) => {
  return {
    type: ACTIVITY_DELETE,
    payload: {
      activity,
    },
  };
};

export const activityResetSearch = () => {
  return {
    type: ACTIVITY_RESET_SEARCH,
    payload: {},
  };
};
